const inboxSettingsWeb = Object.freeze({
  color: 'light',
  colors: {
    inbox_background_color: '',
    inbox_border_color: '',
    inbox_separator_color: '',
    header_background_color: '',
    header_border_color: '',
    header_text_color: '',
    header_icon_color: '',
    switch_on_color: '',
    switch_off_color: '',
    notification_title_color: '',
    notification_text_color: '',
    notification_date_color: ''
  },
  position: 'left',
  switch: 0,
  enabled: 0,
  layout: 'panel',
  button: 'default'
})

export { inboxSettingsWeb }



// WEBPACK FOOTER //
// ./src/modules/settings/enum/WebInboxDefaultSettings.js